import { Box, Container } from "@mui/system";
import React from "react";
import boxStyles from "../../../styles/boxStyles";
import FooterReviewLokasi from "../Component/FooterReviewLokasi";
import KemungkinanPenyebab from "../Component/KemungkinanPenyebab";
import PotensiOutcome from "../Component/PotensiOutcome";

const ReviewLokasi = () => {
  return (
    <div>
      <Container maxWidth={false}>
        <center>
          <h2>LAPORAN KEJADIAN PENTING</h2>
        </center>

        <Box component="div" sx={boxStyles}>
          <PotensiOutcome />
          <KemungkinanPenyebab />
        </Box>

        <br />
        <br />
        <FooterReviewLokasi />
      </Container>
    </div>
  );
};

export default ReviewLokasi;
